// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import parse from 'html-react-parser';

// Styles
import BannerStyles from './banner.styles';

// Components
import Container from '../../container/container';
import Image from '../../image/image';

// Hooks
import useBrandingOptions from '../../../hooks/useBrandingOptions';

export default function Banner({ layout, isFirstLayout, imageLoading }) {
  const bgImg = layout?.backgroundImage;
  const bgColor = layout?.backgroundColour;

  const heading = layout?.heading;
  const text = layout?.text;

  const buttons = layout?.buttons;

  const brandingOptions = useBrandingOptions();

  const displayLogo = layout?.displayLogo;
  const logoImg = brandingOptions?.logo?.localFile?.publicURL;
  const logoAlt = brandingOptions?.logo?.altText || 'Maclynn logo';

  return (
    <BannerStyles text={text} buttons={buttons} bgColor={bgColor}>
      <Image
        image={bgImg}
        backgroundColor="sand"
        background
        loading={imageLoading}
      />

      <Container>
        {displayLogo && logoImg && (
          <img
            className="logo"
            src={logoImg}
            alt={logoAlt}
            width={260}
            height={90}
          />
        )}

        {heading && isFirstLayout ? (
          <h1 className="heading">{parse(heading)}</h1>
        ) : (
          <h2 className="heading large">{parse(heading)}</h2>
        )}

        {text && <div className="text">{parse(text)}</div>}

        {buttons && (
          <div className="btn-group">
            {buttons.map((button) => (
              <Link
                key={button?.button?.title}
                to={button?.button?.url}
                className={`btn ${bgColor === 'white' && 'dark'}`}
              >
                {button?.button?.title}
              </Link>
            ))}
          </div>
        )}
      </Container>
    </BannerStyles>
  );
}

Banner.propTypes = {
  layout: PropTypes.shape({
    height: PropTypes.string,
    displayLogo: PropTypes.bool,
    backgroundImage: PropTypes.shape({
      altText: PropTypes.string,
      gatsbyImage: PropTypes.shape({}),
    }),
    backgroundColour: PropTypes.string,
    heading: PropTypes.string,
    text: PropTypes.string,
    buttons: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  isFirstLayout: PropTypes.bool,
  imageLoading: PropTypes.string.isRequired,
};

Banner.defaultProps = {
  layout: {},
  isFirstLayout: false,
};
